export const getSynonymString = (synonyms: string[] | undefined): string => {
  if (synonyms === undefined || synonyms === null || synonyms?.length === 0) return "";
  if (synonyms.length > 5) {
    const synonymsString = synonyms.slice(0, 5).join(", ");
    return `${synonymsString},...`;
  }
  return synonyms.join(", ");
};
